import Auth from '../auth'
import api from '@/services/api'
import { apiErrorHandler } from '../utils/apiErrors'
// import { objectToSnakeCase } from '../utils'

const QUESTION_ENDPOINT = 'questions/'

// const USERS_IMAGE_ENDPOINT = `/${USERS_ENDPOINT}/profile_pic/`

export default class QuestionAPI {
  /**
   * Instantiate a new `QuestionAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `QuestionAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new QuestionAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  create(question) {
    const url = QUESTION_ENDPOINT
    const data = this.cls.toAPI(question)

    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Create question API error' }))
  }

  update(question, fields = [], excludeFields = []) {
    const url = `${QUESTION_ENDPOINT}${question.id}/`
    let data = this.cls.toAPI(question, fields, excludeFields)

    return this.client
      .patch(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Update Question API error' }))
  }

  /**
   * Get List of questions via the API.
   *
   * @param {object} pagination - Pagination parameters for the API.
   * @param {object} filters - Filter parameters for the API.
   *
   * @returns {Promise} - Contains the list of `question` instances.
   */
  list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const url = QUESTION_ENDPOINT
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }
    if (filters.project) {
      options.params.project = filters.project
    }
    if (filters.answered) {
      options.params.answered = filters.answered
    }
    if (filters.page) {
      options.params.page = filters.page
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => ({
        ...data,
        results: data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'Question API error' }))
  }
}
